// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#fc127f","container":"container__ZezZq","mail":"mail__1O05_"};